// Async action to fetch exchange rate
import { RootState } from 'redux/store'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { getCurrencySymbol } from '../../../../utils/functions/currencyUtils'

export const fetchExchangeRate = createAsyncThunk(
  'currency/fetchExchangeRate',
  async (newCurrency: string, { getState, rejectWithValue }) => {
    const state = getState() as RootState

    const defaultCurrency = state.config.currency.default || 'USD'

    try {
      const response = await fetch(
        `/embedded/api/currency?fromCurrency=${defaultCurrency}&toCurrency=${newCurrency}`,
      )

      if (!response.ok) throw new Error('Failed to fetch exchange rate')

      const { rate } = await response.json()
      if (typeof rate !== 'number' || isNaN(rate)) throw new Error('Invalid exchange rate')

      return {
        value: newCurrency,
        exchangeRate: rate,
        symbol: getCurrencySymbol(newCurrency) || newCurrency,
      }
    } catch (error) {
      return rejectWithValue((error as Error).message)
    }
  },
)
